import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { FreeMode, Navigation } from "swiper";

export default function SkillDashboardComponent({
  selectedSkill,
  skillsTagsAdded,
  onSkillUnselectClick,
  onSkillsChange,
}) {
  return (
    <Swiper
      slidesPerView={"auto"}
      spaceBetween={5}
      modules={[FreeMode, Navigation]}
      className="custom-tab-slider"
      navigation={true}
      loop={true}
    >
      {skillsTagsAdded &&
       Array.isArray(skillsTagsAdded) &&
        skillsTagsAdded.map((tag, index) => (
          <SwiperSlide>
            <span
              className={`d-flex align-items-center h4  py-1 border rounded-pill font-weight-normal cursor-pointer ${
                selectedSkill === tag
                  ? "bg-primary-light border-primary text-primary"
                  : "text-grey-4 bg-white"
              } px-2 text-capitalize`}
              key={index}
            >
              <span onClick={() => onSkillsChange(tag)}>
                {tag?.skill_name ? tag?.skill_name : tag?.skill}
              </span>
              <FontAwesomeIcon
                icon={faXmark}
                onClick={onSkillUnselectClick}
                className="ml-2"
              />
            </span>
          </SwiperSlide>
        ))}
    </Swiper>
  );
}
